// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"484b1e52d0190641524d","263":"8df41d2671dfa891982b","791":"3bb97b6f2a37b94aa451"}[chunkId] + ".js";
};